import { useEffect } from "react";

function upsertMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

interface MetaOptions {
  title: string;
  description: string;
  keywords?: string;
}

/**
 * Sets document title and core SEO meta tags for the current page.
 */
export default function useMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta("description", description);
    if (keywords) upsertMeta("keywords", keywords);
    upsertMeta("og:title", title);
    upsertMeta("og:description", description);
  }, [title, description, keywords]);
}